import { createIcon } from '@chakra-ui/icons';

export const DeleteCompact = createIcon({
  displayName: 'DeleteCompact',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.6875 6.125H4.8125C4.57088 6.125 4.375 6.32088 4.375 6.5625V10.9375C4.375 11.1791 4.57088 11.375 4.8125 11.375H5.6875C5.92912 11.375 6.125 11.1791 6.125 10.9375V6.5625C6.125 6.32088 5.92912 6.125 5.6875 6.125Z"
        fill="currentColor"
      />
      <path
        d="M9.1875 6.125H8.3125C8.07088 6.125 7.875 6.32088 7.875 6.5625V10.9375C7.875 11.1791 8.07088 11.375 8.3125 11.375H9.1875C9.42912 11.375 9.625 11.1791 9.625 10.9375V6.5625C9.625 6.32088 9.42912 6.125 9.1875 6.125Z"
        fill="currentColor"
      />
      <path
        d="M13.125 2.625H9.625V0.875C9.625 0.642936 9.53281 0.420376 9.36872 0.256282C9.20462 0.0921872 8.98206 0 8.75 0L5.25 0C5.01794 0 4.79538 0.0921872 4.63128 0.256282C4.46719 0.420376 4.375 0.642936 4.375 0.875V2.625H0.875C0.642936 2.625 0.420376 2.71719 0.256282 2.88128C0.0921872 3.04538 0 3.26794 0 3.5C0 3.73206 0.0921872 3.95462 0.256282 4.11872C0.420376 4.28281 0.642936 4.375 0.875 4.375H13.125C13.3571 4.375 13.5796 4.28281 13.7437 4.11872C13.9078 3.95462 14 3.73206 14 3.5C14 3.26794 13.9078 3.04538 13.7437 2.88128C13.5796 2.71719 13.3571 2.625 13.125 2.625ZM6.125 1.75H7.875V2.625H6.125V1.75Z"
        fill="currentColor"
      />
      <path
        d="M11.375 12.25H2.625V5.25H0.875V12.25C0.875 12.7141 1.05937 13.1592 1.38756 13.4874C1.71575 13.8156 2.16087 14 2.625 14H11.375C11.8391 14 12.2842 13.8156 12.6124 13.4874C12.9406 13.1592 13.125 12.7141 13.125 12.25V5.25H11.375V12.25Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
